// src/api/quizScenarioApi.js

// Fetches scenario-based quizzes from the Lambda API.
// Returns an array of quiz objects if successful, or an empty array if an error occurs.

export const fetchScenarioQuizzes = async () => {
  try {
    // Send GET request to the scenario quiz API endpoint
    const response = await fetch(
      "https://zg3olhj6ke.execute-api.us-east-1.amazonaws.com/quiz/multiple",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Throw error if the response is not successful
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    // Parse the response JSON
    const data = await response.json();

    // Ensure the return value is always an array
    return data.quizzes || [];
  } catch (error) {
    // Log error and return empty array as fallback
    console.error("Error fetching scenario quizzes:", error);
    return [];
  }
};
